import { GetForwardRefExoticComponentProps } from "types";
import { createButton } from "./ButtonBase";

type HTMLAnchorAttributes = React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>;

export type AnchorButtonProps = GetForwardRefExoticComponentProps<typeof AnchorButton>;
export const AnchorButton = createButton<HTMLAnchorElement, HTMLAnchorAttributes>("a");
